/**
 * FamLoader — branded loading indicator using the FAM badge icon.
 * Animation: fade in → fill with gradient glow → fade out → repeat.
 */

const KEYFRAMES = `
  @keyframes fam-fill {
    0%   { opacity: 0;   transform: scale(0.72); filter: blur(2px); }
    35%  { opacity: 1;   transform: scale(1.06); filter: blur(0);   }
    55%  { opacity: 1;   transform: scale(1);    filter: blur(0);   }
    80%  { opacity: 1;   transform: scale(1);    filter: blur(0);   }
    100% { opacity: 0;   transform: scale(0.82); filter: blur(1px); }
  }
  @keyframes fam-glow {
    0%   { box-shadow: 0 0 0px  0px rgba(79,70,229,0);    }
    45%  { box-shadow: 0 0 28px 8px  rgba(124,58,237,0.45); }
    80%  { box-shadow: 0 0 28px 8px  rgba(225,29,72,0.30); }
    100% { box-shadow: 0 0 0px  0px rgba(79,70,229,0);    }
  }
  .fam-badge-fill {
    animation: fam-fill 1.8s ease-in-out infinite, fam-glow 1.8s ease-in-out infinite;
  }
`;

interface FamLoaderProps {
  /** full-screen white overlay (default) */
  fullScreen?: boolean;
  size?: number;
  label?: string;
}

export function FamLoader({ fullScreen = true, size = 64, label }: FamLoaderProps) {
  const fontSize = Math.round(size * 0.45);
  const radius   = Math.round(size * 0.22);

  return (
    <>
      <style>{KEYFRAMES}</style>
      <div
        className={
          fullScreen
            ? 'fixed inset-0 z-[9999] bg-white flex flex-col items-center justify-center gap-5'
            : 'flex flex-col items-center justify-center gap-4 py-16'
        }
      >
        {/* Badge */}
        <div
          className="fam-badge-fill flex items-center justify-center"
          style={{
            width: size,
            height: size,
            borderRadius: radius,
            background: 'linear-gradient(135deg,#4f46e5 0%,#7c3aed 50%,#e11d48 100%)',
          }}
        >
          <span
            style={{ fontSize, lineHeight: 1 }}
            className="text-white font-black select-none"
          >
            F
          </span>
        </div>

        {/* Label */}
        {label && (
          <p className="text-sm text-gray-400 font-medium tracking-wide">{label}</p>
        )}
      </div>
    </>
  );
}
